import React from "react";
import { withLocalize } from "react-localize-redux";
import { connect as connectFormik } from 'formik';
import BbCheckbox from "../../styling/bbCheckbox";
import BbFormikCheckbox from "../../styling/bbFormikCheckbox";

class Msp extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="columns is-multiline">
                    <div className="column is-12" style={{ paddingBottom: 0 }}>
                        <div className="bb-chk-grp-all">
                            <BbCheckbox label={this.props.translate("Charts.CheckAll")} value={this.isAllChecked} id="all-msp" onChange={(c) => this.checkAll(c)} />
                        </div>
                    </div>
                    <div className="column is-6" style={{ paddingTop: 0 }} >
                        <BbFormikCheckbox label={this.props.translate("Report.EconomicGroup.SME.Total")} name="msp.total" id="mspTotal" />
                        <BbFormikCheckbox label={`${this.props.translate("Report.EconomicGroup.SME.ComputedEmployeesCount")} `} name="msp.computedEmployeesCount" id="mspComputedEmployeesCount" />
                        <BbFormikCheckbox label={`${this.props.translate("Report.EconomicGroup.SME.ComputedTurnover")}`} name="msp.computedTurnover" id="mspComputedTurnover" />
                        <BbFormikCheckbox label={this.props.translate("Report.EconomicGroup.SME.ComputedAssets")} name="msp.computedAssets" id="mspComputedAssets" />
                    </div>
                    <div className="column is-6" style={{ paddingTop: 0 }}>
                            <BbFormikCheckbox label={this.props.translate("Report.EconomicGroup.SME.Ovm")} name="msp.ovm" id="mspOvm" />
                            <BbFormikCheckbox label={this.props.translate("Report.EconomicGroup.SME.PartnersCount")} name="msp.partnersCount" id="mspPartnersCount" />
                            <BbFormikCheckbox label={this.props.translate("Report.EconomicGroup.SME.ConnectedPartners")} name="msp.connectedPartners" id="mspConnectedPartners" />
                            <BbFormikCheckbox label={this.props.translate("Report.EconomicGroup.SME.ConnectedPartnersSubjects")} name="msp.connectedPartnersSubjects" id="mspConnectedPartnersSubjects" />
                    </div>
                </div>
            </React.Fragment>
        )
    }

    get isAllChecked() {
        let checkedCount = this.checkboxes.filter(x => x[1] === true).length;
        let allCount = this.checkboxes.length;
        if (checkedCount === 0) { return false };
        if (checkedCount === allCount) { return true };
        return null;
    }

    checkAll(value) {
        let newState = Object.assign({}, this.props.formik.values.msp);
        Object.keys(newState).filter(x => typeof newState[x] === "boolean").map((c) => {
            newState[c] = value;
        });
        this.props.formik.setFieldValue("msp", newState);

    }
    get checkboxes() {
        return Object.entries(this.props.formik.values.msp).filter(x => x[0] !== "isChecked" && typeof x[1] === "boolean");
    }
}

export default withLocalize(connectFormik(Msp));
